import Component from "./eventProfile";

import { bindActionCreators } from "redux";
import {
  getEventById,
  joinEvent,
  reCreateTeam,
  getCheck,
} from "../../store/actions/event";
import { getTeams } from "../../store/actions/teams";
import { getTeamsByEventId } from "../../store/actions/all_teams";
import { getTeamProfile } from "../../store/actions/team";
import { getUserProfile } from "../../store/actions/user";
import connect from "react-redux/es/connect/connect";


function mapStateToProps(state) {
  const event = state.event;
  const teams = state.teams;
  const team = state.team;
  const all_teams = state.all_teams;
  const session = state.session;
  const check = state.check;
  const user = state.user;

  return {
    event,
    teams,
    all_teams,
    team,
    session,
    check,
    user
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getEventById,
      getTeamsByEventId,
      getTeams,
      joinEvent,
      reCreateTeam,
      getCheck,
      getTeamProfile,
      getUserProfile
    },
    dispatch
  );
}

export const EventProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
